import React from "react";
import Menu from "../Menu";
import Footer from "../footer";
import MetaTags from "react-meta-tags";
import ReactGA from "react-ga";

export default function info() {
  return (
    <div>
      <MetaTags>
        <title>Справка | Быстрый кредит онлайн в Украине ➣ Просто Гроші</title>
        <meta
          name="description"
          content="Справка | Займы до 10000 грн наличными ✨ без отказа ✅ онлайн на карту ⭐ быстро ⏰ Просто Гроші"
        />
      </MetaTags>
      <Menu />
      <div className="main-block">
        <div className="main-block-info">
          <div className="main-block-info-left">
            <h1>Довідка</h1>
          </div>
          <div className="main-block-info-right">
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Яку суму можна отримати у кредит за першого звернення?</strong>
              </p>
              <p dir="ltr">Ви можете отримати від 400 до 50 000 грн.</p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Який відсоток за кредитом?</strong>
              </p>
              <p dir="ltr">
                У нас фіксовані відсотки за користування кредитом, сума відсотків залежить від розміру та строку кредиту.
              </p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Які обмеження для отримання кредиту?</strong>
              </p>
              <p dir="ltr">Вік позичальника від 18 до 70 років.</p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Які документи необхідні для отримання кредиту?</strong>
              </p>
              <p dir="ltr">Оригінал паспорта та ідентифікаційний код.</p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Чи можу я отримати кредит без довідки про доходи?</strong>
              </p>
              <p dir="ltr">Ми надаємо кредити без довідки про доходи.</p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>На яку мету дають кредит?</strong>
              </p>
              <p dir="ltr">Гроші видаються на будь-які цілі.</p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Для отримання кредиту потрібні запоруки, поручителі?</strong>
              </p>
              <p dir="ltr">Ми надаємо кредити без застави та поручителів.</p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Які є додаткові комісії із кредиту?</strong>
              </p>
              <p dir="ltr">
                У нас відсутні приховані комісії, додаткові платежі, страховки, перші внески та інше. Ви сплачуєте лише відсотки за користування кредитом.
              </p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Як сплачувати кредит?</strong>
              </p>
              <p dir="ltr">
                Для погашення кредиту Ви можете звернутися до будь-якого відділення, внести платіж через банк або сплатити з Вашої картки Visa/Master Card на нашому сайті.
              </p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Чи можу я оплатити кредит через банк?</strong>
              </p>
              <p dir="ltr">Ви можете сплатити кредит у будь-якому відділенні банку або через термінал.</p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Чи може замість клієнта оплачувати кредит інша людина?</strong>
              </p>
              <p dir="ltr">
                Так, замість Клієнта, за його згодою, сплатити кредит може інша людина.
              </p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Чи можна продовжити термін користування кредитом?</strong>
              </p>
              <p dir="ltr">
                Можна продовжити термін користування кредитом, для цього потрібно сплатити відсотки за продовження.
              </p>
            </div>
            <div className="infoBlock">
              <p dir="ltr">
                <strong>Чи можна погашати кредит раніше?</strong>
              </p>
              <p dir="ltr">
                Кредит можна погашати достроково, при цьому Ви сплачуєте лише за фактичні дні користування грошима.
              </p>
            </div>

            <p>
              Ми – спеціалізована фінансова компанія «Споживчий Центр». Ми зареєстровані Національною комісією, що здійснює державне регулювання у сфері ринків фінансових послуг, свідоцтво про реєстрацію фінансової установи ІК №78. Єдиний вид діяльності компанії – видача кредитів. Відомості про державну реєстрацію ТОВ "Споживчий центр": дата запису в Єдиному державному реєстрі про проведення державної реєстрації юридичної особи - 11.11.2010, номер запису - 1 074 102 0000 038148. Ліцензія видана Нацкомфінпослуг, розпорядження від 28.02.2017 р. №438.
            </p>

            <p>
              <h3>Для отримання кредиту:</h3>
                Приклад розрахунку: при сумі кредиту в 2000 грн., проценти за користування коштами складуть 40 грн. в день, що становить 2% в день. APR – 730%. Ніяких додаткових комісій та платежів за користування кредитом Компанія не стягує. При укладенні договору з умовою, коли кредит погашається частинами, сплачується комісія за надання кредиту.
            </p>
            <p>
              Фінансова відповідальність, що накладається на Позичальника у разі невиконання зобов'язань перед фінансовим партнером:
            </p>
            <ul>
              <li>
                Може бути розпочато процес примусового стягнення боргу чи можлива передача права вимоги боргу третім особам.
              </li>
              <li>
                У випадку невиконання/неналежного виконання Позичальником будь-яких грошових зобов’язань за Договором Кредитор залишає за собою право нарахування неустойки, розмір якої складає 2% в день від суми виданого кредиту за кожен день невиконання/неналежного виконання кожного окремого зобов'язання незалежно від суми невиконаного/неналежно виконаного зобов'язання.
              </li>
              <li>
                Невиконання зобов’язань перед Фінансовим партнером може негативно відобразитися на кредитній історії Позичальника, а також вплинути на кредитний рейтинг Позичальника, що, в свою чергу, може стати причиною відмови в наданні послуг як Партнером, так і третіми особами.
              </li>
            </ul>
          </div>
        </div>
      </div>
      {ReactGA.pageview("/faq")}
      <Footer />
    </div>
  );
}



// WEBPACK FOOTER //
// src/pages/info.js